import React from 'react';
import { Col, Grid, Row } from 'react-bootstrap';
import { connect } from "react-redux";
import { LinkContainer } from 'react-router-bootstrap';
import { branch, compose, renderComponent } from "recompose";
import { bindActionCreators } from 'redux';
import { routes } from '../../../../constants';
import link from '../../../../images/glyphicon-basic/glyphicons-basic-351-link@3x.png';
import paperclip from '../../../../images/glyphicon-basic/glyphicons-basic-63-paperclip@3x.png';
import education from '../../../../images/glyphicon-basic/glyphicons-basic-68-education@3x.png';
import { isBusinessAdmin } from '../../../../services';
import { taskActions } from '../../../../state/modules/task';
import Loading from '../../loading';
import { taskTypes } from './config';

const ChooseTaskType = ({
  setTaskType,
  setCpdAllocation
}) => (<div id="choose-task-type">
  <Grid>
    <Row className='no-gutter'>
      <Col xs={12} md={8} mdOffset={2} className='no-padding'>
        <h1>What type of task is this?</h1>
      </Col>
    </Row>
    <Row className='no-gutter'>
      <Col xs={12} md={4} className='no-padding'>
        <LinkContainer onClick={() => {
          setTaskType(taskTypes.CADDIE);
          setCpdAllocation(true);
        }} className="type-tile" to={routes.app.tasks.details}>
          <div>
            <img className="task-type" src={education} alt="CPD content" />
            <h2>Caddie CPD Content</h2>
            <p>
              Select one or multiple Caddie CPD
              content items for your team members
              to complete. All Caddie CPD content
              tasks will count towards a user's
              overall CPD progress.
          </p>
          </div>
        </LinkContainer>
      </Col>
      <Col xs={12} md={4} className='no-padding'>
        <LinkContainer onClick={() => setTaskType(taskTypes.ATTACHMENT)} className="type-tile" to={routes.app.tasks.chooseCpdAllocation}>
          <div>
            <img className="task-type" src={paperclip} alt="attachment" />
            <h2>Attachment Upload</h2>
            <p>
              Upload a PDF for your team to review,
              such as a workplace policy, an in-house
              CPD article, or something else that may
              be interesting.
          </p>
          </div>
        </LinkContainer>
      </Col>
      <Col xs={12} md={4} className='no-padding'>
        <LinkContainer onClick={() => setTaskType(taskTypes.EXTERNAL)} className="type-tile" to={routes.app.tasks.chooseCpdAllocation}>
          <div>
            <img className="task-type" src={link} alt="external link" />
            <h2>External Link</h2>
            <p>
              Send your team a URL to review, such as a
              news article, online PDF, or something else
              that may be interesting.
          </p>
          </div>
        </LinkContainer>
      </Col>
    </Row>
  </Grid>
</div>);

const mapStateToProps = (state) => ({
  isBusinessAdmin: isBusinessAdmin(state.user.currentUser)
});

const mapDispatchToProps = (dispatch) => ({
  setTaskType: bindActionCreators(taskActions.task.chooseTaskType, dispatch),
  setCpdAllocation: bindActionCreators(taskActions.task.setCpdAllocation, dispatch)
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  branch(
    ({ isBusinessAdmin }) => !isBusinessAdmin,
    renderComponent(Loading)
  )
)(ChooseTaskType)


// WEBPACK FOOTER //
// ./src/containers/pages/app/tasks/choose-task-type.js